import type { LeagueMember } from "@tnp/contracts";
import Button from "../../../../shared/components/Button";
import { getLeagueRosterTexts } from "../../shared/leagueRosterTexts";
import EmptyState from "../../../../shared/components/EmptyState";

type Props = { members: LeagueMember[]; locked: boolean; onMove: (index: number, direction: -1 | 1) => void; onRemove: (userId: number) => void };
export default function LeagueRosterList({ members, locked, onMove, onRemove }: Props) {
  const t = getLeagueRosterTexts();
  return <section className="league-panel">
    <h2>{t.seed}</h2>
    {members.length > 0 && <details className="league-roster-help">
      <summary>{t.help}</summary>
      <p>{t.hint}</p>
      <p>{t.previewHint}</p>
    </details>}
    {!members.length && <EmptyState title={t.empty} iconName="sports_tennis" />}
    <ol className="league-athlete-list">{members.map((member, index) => <li key={member.userId}>
      <span>{index + 1}. {member.name}{member.category && <small>{t.category}: {member.category}</small>}</span>
      {!locked && <div className="league-actions">
        <Button type="button" variant="ghost" aria-label={`${t.up}: ${member.name}`} disabled={index === 0} onClick={() => onMove(index, -1)}><span className="material-symbols-outlined" aria-hidden="true">arrow_upward</span></Button>
        <Button type="button" variant="ghost" aria-label={`${t.down}: ${member.name}`} disabled={index === members.length - 1} onClick={() => onMove(index, 1)}><span className="material-symbols-outlined" aria-hidden="true">arrow_downward</span></Button>
        <Button type="button" variant="ghost" aria-label={`${t.remove}: ${member.name}`} onClick={() => onRemove(member.userId)}>{t.remove}</Button>
      </div>}
    </li>)}</ol>
  </section>;
}
